export default "__VITE_ASSET__3x9rwmym__"